import { put, call, fork, select, throttle, all, takeEvery } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import * as routes from '../../components/index/routes';
import { reset as resetForm, stopSubmit } from 'redux-form';
import * as testDevicesModule from '../modules/testDevices.module';
import * as Api from '../../core/api';

export function* fetchTestDevices({ payload: { page, itemsPerPage } }) {
  const sort = yield select((state) => state.testDevices.sort);
  const filter = yield select((state) => state.testDevices.filter);

  const { response, error } = yield call(Api.testDevices.fetchTestDevices, { page, itemsPerPage, sort, filter });

  if (response) {
    yield put(testDevicesModule.fetchTestDevicesSuccess({ testDevices: response, filter }));
  } else {
    yield put(testDevicesModule.fetchTestDevicesFail(error));
  }
}
export function* watchFetchTestDevices() {
  yield takeEvery(testDevicesModule.fetchTestDevices.getType(), fetchTestDevices);
}

export function* addTestDevice({ payload: testDevice }) {
  const { response, error } = yield call(Api.testDevices.addTestDevice, testDevice);

  if (response) {
    yield put(testDevicesModule.addTestDeviceSuccess(response));
    yield put(testDevicesModule.closeEditTestDevice());
    yield put(resetForm('addTestDevice'));
  } else {
    yield put(testDevicesModule.addTestDeviceFail(error));
  }
}
export function* watchAddTestDevice() {
  yield takeEvery(testDevicesModule.addTestDevice.getType(), addTestDevice);
}

export function* updateTestDevice({ payload: { testDeviceId, testDevice } }) {
  const { response, error } = yield call(Api.testDevices.updateTestDevice, { testDeviceId, testDevice });

  if (response) {
    yield put(testDevicesModule.updateTestDeviceSuccess({
      testDeviceId,
      testDevice,
    }));
    yield put(testDevicesModule.closeEditTestDevice());
    yield put(resetForm('editTestDevice'));
  } else {
    yield put(testDevicesModule.updateTestDeviceFail(error));
  }
}
export function* watchUpdateTestDevice() {
  yield takeEvery(testDevicesModule.updateTestDevice.getType(), updateTestDevice);
}

export function* deleteTestDevice({ payload: { testDeviceId } }) {
  const { response, error } = yield call(Api.testDevices.deleteTestDevice, { testDeviceId });

  if (response) {
    yield put(testDevicesModule.deleteTestDeviceSuccess({ testDeviceId }));
  } else {
    yield put(testDevicesModule.deleteTestDeviceFail(error));
  }
}
export function* watchDeleteTestDevice() {
  yield takeEvery(testDevicesModule.deleteTestDevice.getType(), deleteTestDevice);
}

export default function* watchTestDevices() {
  return yield all([
    fork(watchFetchTestDevices),
    fork(watchAddTestDevice),
    fork(watchUpdateTestDevice),
    fork(watchDeleteTestDevice),
  ]);
}




/** WEBPACK FOOTER **
 ** ./js/redux/saga/testDevices.saga.js
 **/